export default __webpack_public_path__ + "static/media/ri.f703b658.jpg";